import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ComposedChart, Area, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import henceforthApi from '../utils/henceforthApi';




const Graph = ({ data, totalsales, totalhours }: any) => {
    
    // Determine the correct x-axis key based on the data structure
    const getXAxisKey = () => {
        if (!data || data.length === 0) return '';
        const firstItem = data[0];
        if ('hour' in firstItem) return 'hour';
        if ('day' in firstItem) return 'day';
        if ('date' in firstItem) return 'date';
        if ('month' in firstItem) return 'month';
        return '';
    };
    
    const xAxisKey = getXAxisKey();
  
 
    return (
        <ResponsiveContainer width={'100%'} height={300}>
            <ComposedChart width={600} height={300} data={data}>
                <XAxis dataKey={xAxisKey} stroke="#2f4050" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Area type="monotone" dataKey={totalsales} fill="#8928a73d" stroke="#2f4050" />
            </ComposedChart>
        </ResponsiveContainer>
    )

}
export default Graph;
